import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../../../components/base/PageLayout';

const MannerCourse: React.FC = () => {
  useEffect(() => {
    document.title = 'マナー講座 - 執事から学ぶテーブルマナー・ビジネスマナー教室｜執事ベル';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '執事ベルによる個人向けマナー講座のご案内。テーブルマナー、ビジネスマナー、社交エチケット、立ち居振る舞いなど、目的に応じたプライベートレッスンを提供。完全マンツーマンで、一人ひとりのレベルと目標に合わせたカリキュラムを作成。就職活動、昇進、海外赴任、結婚式、社交デビューなど、人生の大切な場面で自信を持って振る舞えるマナーを身につけられます。');
    }
  }, []);

  const courses = [
    {
      title: 'テーブルマナー講座',
      description: '正式なテーブルマナーを基礎から応用まで学ぶ',
      duration: '2時間',
      price: '3万円',
      level: '初級〜上級',
      features: [
        'カトラリーの使い方',
        'ナプキンの扱い方',
        '食事の作法',
        'ワインマナー',
        '会話のエチケット'
      ],
      image: '/images/generated/seq-table-manner-c36235.jpg'
    },
    {
      title: 'ビジネスマナー講座',
      description: 'ビジネスシーンで必要な基本マナーを習得',
      duration: '2時間',
      price: '3万円',
      level: '初級〜中級',
      features: [
        '挨拶・お辞儀の仕方',
        '名刺交換',
        '電話応対',
        'メールマナー',
        '会議での振る舞い'
      ],
      image: '/images/generated/seq-business-manner-05cfda.jpg'
    },
    {
      title: '冠婚葬祭マナー講座',
      description: '人生の重要な場面での適切な振る舞いを学ぶ',
      duration: '2時間',
      price: '3万円',
      level: '初級〜中級',
      features: [
        '結婚式でのマナー',
        '葬儀でのマナー',
        '服装の選び方',
        'ご祝儀・香典',
        '挨拶・スピーチ'
      ],
      image: '/images/generated/seq-ceremony-manner-1c93fe.jpg'
    },
    {
      title: '国際マナー講座',
      description: '国際的な場面で通用するマナーとプロトコル',
      duration: '3時間',
      price: '5万円',
      level: '中級〜上級',
      features: [
        '国際プロトコル',
        '各国の文化理解',
        '英語での挨拶',
        '国際会議マナー',
        'パーティーエチケット'
      ],
      image: '/images/generated/seq-international-manner-91518b.jpg'
    }
  ];

  const benefits = [
    {
      icon: 'ri-user-star-line',
      title: '自信の向上',
      description: '正しいマナーを身につけることで、どんな場面でも自信を持って振る舞えます'
    },
    {
      icon: 'ri-team-line',
      title: '人間関係の改善',
      description: '適切なマナーにより、周囲との関係がより良好になります'
    },
    {
      icon: 'ri-trophy-line',
      title: 'キャリアアップ',
      description: 'ビジネスマナーの習得により、職場での評価向上につながります'
    },
    {
      icon: 'ri-heart-line',
      title: '品格の向上',
      description: '内面から滲み出る品格を身につけることができます'
    }
  ];

  return (
    <PageLayout hero={<>
<section 
          className="relative py-32 bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('/images/gakken/gk-02.jpg')`
          }}
        >
          <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
            <div className="text-center text-white">
              <h1 className="text-4xl md:text-6xl font-serif mb-6">
                マナー講座
              </h1>
              <p className="text-xl md:text-2xl max-w-6xl mx-auto leading-relaxed">
                人生を豊かにする<br />
                本物のマナーを身につける
              </p>
            </div>
          </div>
        </section>
</>}>
      <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white">
        {/* Hero Section */}
        

        {/* Overview */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-6">
                  真のマナーは<br />
                  心から生まれる
                </h2>
                <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                  マナーとは単なる形式ではありません。相手を思いやる心から自然に生まれる美しい振る舞いです。執事文化の研究と実践を通じて学んだ知見を、形だけでなく心の在り方から丁寧にお伝えいたします。
                </p>
                <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                  少人数制の個別指導により、お一人お一人のペースに合わせて、実践的なマナーを身につけていただけます。一方的に教えるのではなく、共に学び、共に成長できる場を大切にしています。
                </p>
                <div className="grid grid-cols-3 gap-6">
                  <div className="text-center p-4 bg-amber-50 rounded-lg">
                    <div className="text-2xl font-bold text-amber-700 mb-2">少人数</div>
                    <div className="text-sm text-gray-600">個別指導</div>
                  </div>
                  <div className="text-center p-4 bg-amber-50 rounded-lg">
                    <div className="text-2xl font-bold text-amber-700 mb-2">実践</div>
                    <div className="text-sm text-gray-600">重視</div>
                  </div>
                  <div className="text-center p-4 bg-amber-50 rounded-lg">
                    <div className="text-2xl font-bold text-amber-700 mb-2">共に</div>
                    <div className="text-sm text-gray-600">学ぶ姿勢</div>
                  </div>
                </div>
              </div>
              <div>
                <img
                  src="/images/generated/seq-manner-instruction-746099.jpg"
                  alt="マナー講座の様子"
                  className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Courses */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-4">
                講座一覧
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                様々なシーンに対応した実践的なマナー講座
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {courses.map((course, index) => (
                <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
                  <img
                    src={course.image}
                    alt={course.title}
                    className="w-full aspect-[16/9] h-auto object-cover object-top"
                  />
                  <div className="p-8">
                    <h3 className="text-2xl font-serif text-gray-900 mb-4">
                      {course.title}
                    </h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">
                      {course.description}
                    </p>
                    
                    <div className="grid grid-cols-3 gap-4 mb-6 text-sm">
                      <div>
                        <span className="font-medium text-gray-900">時間：</span>
                        <span className="text-gray-600">{course.duration}</span>
                      </div>
                      <div>
                        <span className="font-medium text-gray-900">料金：</span>
                        <span className="text-amber-700 font-medium">{course.price}</span>
                      </div>
                      <div>
                        <span className="font-medium text-gray-900">レベル：</span>
                        <span className="text-gray-600">{course.level}</span>
                      </div>
                    </div>

                    <div className="mb-6">
                      <h4 className="text-lg font-medium text-gray-900 mb-3">学習内容</h4>
                      <ul className="space-y-2">
                        {course.features.map((feature, featureIndex) => (
                          <li key={featureIndex} className="flex items-center text-gray-700">
                            <div className="w-2 h-2 bg-amber-500 rounded-full mr-3 flex-shrink-0"></div>
                            <span className="text-sm">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <Link
                      to="/contact"
                      className="btn-gold block w-full bg-amber-700 text-white text-center py-3 rounded-lg font-medium hover:bg-amber-800 transition-colors whitespace-nowrap"
                    >
                      お申し込み
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-4">
                マナーを学ぶメリット
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {benefits.map((benefit, index) => (
                <div key={index} className="text-center">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-amber-100 rounded-full">
                    <i className={`${benefit.icon} text-2xl text-amber-700`}></i>
                  </div>
                  <h3 className="text-xl font-serif text-gray-900 mb-4">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-4">
                講座で大切にしていること
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  title: '心の在り方',
                  description: 'マナーの本質は相手を思いやる心です。形だけでなく、心から生まれる美しい振る舞いを目指します。',
                  icon: 'ri-heart-line'
                },
                {
                  title: '実践的な学び',
                  description: '日常生活やビジネスシーンですぐに活かせる、実践的な内容を中心にお伝えします。',
                  icon: 'ri-lightbulb-line'
                },
                {
                  title: '共に成長',
                  description: '一方的に教えるのではなく、参加者の皆様と共に考え、共に学ぶ場を大切にしています。',
                  icon: 'ri-team-line'
                }
              ].map((value, index) => (
                <div key={index} className="bg-white rounded-lg shadow-lg p-6">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-amber-100 rounded-full">
                    <i className={`${value.icon} text-2xl text-amber-700`}></i>
                  </div>
                  <h3 className="text-lg font-serif text-gray-900 mb-3 text-center">{value.title}</h3>
                  <p className="text-gray-700 text-sm leading-relaxed text-center">
                    {value.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-4">
                受講者の声
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  name: '田中様',
                  age: '30代女性',
                  course: 'テーブルマナー講座',
                  comment: '結婚式でのマナーに不安がありましたが、丁寧な指導のおかげで自信を持って参加できました。',
                  rating: 5
                },
                {
                  name: '佐藤様',
                  age: '40代男性',
                  course: 'ビジネスマナー講座',
                  comment: '昇進後の接待で役立ちました。相手の方からもお褒めの言葉をいただけて嬉しかったです。',
                  rating: 5
                },
                {
                  name: '山田様',
                  age: '20代女性',
                  course: '国際マナー講座',
                  comment: '海外出張が多いので受講しました。国際的な場面でも堂々と振る舞えるようになりました。',
                  rating: 5
                }
              ].map((testimonial, index) => (
                <div key={index} className="bg-white rounded-lg shadow-lg p-6">
                  <div className="flex mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-amber-500"></i>
                    ))}
                  </div>
                  <p className="text-gray-700 mb-4 leading-relaxed italic">
                    "{testimonial.comment}"
                  </p>
                  <div>
                    <div className="font-medium text-gray-900">{testimonial.name}</div>
                    <div className="text-sm text-gray-600">{testimonial.age} / {testimonial.course}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-amber-700 to-amber-800">
          <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-serif text-white mb-6">
              美しいマナーを身につけませんか
            </h2>
            <p className="text-xl text-amber-100 mb-8 leading-relaxed">
              まずはお気軽にご相談ください。あなたに最適な講座をご提案いたします
            </p>
            <Link
              to="/contact"
              className="btn-gold inline-block bg-white text-amber-800 px-8 py-4 rounded-lg font-medium hover:bg-amber-50 transition-colors whitespace-nowrap"
            >
              講座のお申し込み
            </Link>
          </div>
        </section>
      </div>
    </PageLayout>
  );
};

export default MannerCourse;
